import type { RTPGrouping } from '@/types/rtpDownload';

export const RTP_GROUPING_LABELS: Record<RTPGrouping, string> = {
  hour: 'Per Hour',
  day: 'Per Day',
  week: 'Per Week',
  month: 'Per Month',
};

export function formatRTPDateTime(isoString: string | null): string {
  if (!isoString) return 'Not set';

  const date = new Date(isoString);
  return date.toLocaleString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });
}
